import { useContext } from 'react';
import { shallowEqual } from 'react-redux';
import { Icon } from '@zillow/constellation-10';
import { IconUserGroupFilled } from '@zillow/constellation-icons';

import { RMWContext } from '../../../providers/RMWContext';
import { useSelector } from '../../../selectors/useSelector';
import EmptyState from '../../EmptyState';

const NoInterestedRenters = () => {
  const { paths } = useContext(RMWContext);

  const {
    listingAlias,
    isEnabled: isScreeningCriteriaEnabled,
    isSet: isScreeningCriteriaSet,
    dateLastActivatedTimestamp,
  } = useSelector((state) => {
    return {
      listingAlias: state.properties.propertyOverview.listingAlias,
      isEnabled: state.properties.propertyOverview.screeningCriteria.isEnabled,
      isSet: state.properties.propertyOverview.screeningCriteria.isSet,
      dateLastActivatedTimestamp: state.properties.currentProperty.dateLastActivatedTimestamp,
    };
  }, shallowEqual);

  const showScreeningCriteriaCTA = isScreeningCriteriaEnabled && dateLastActivatedTimestamp !== '';

  const bodyPrefix = isScreeningCriteriaSet ? 'Adjusting your' : 'Setting screening';
  const screeningCriteriaBody = `${bodyPrefix} criteria could help attract more renters to your property.`;
  const screeningCriteriaPath = `${paths.propertiesPage}/${listingAlias}/screening-criteria`;
  const screeningCriteriaLabel = isScreeningCriteriaSet ? 'Adjust screening preferences' : 'Set screening preferences';

  return (
    <EmptyState
      data-testid="EmptyInterestedRentersCard"
      icon={<Icon render={<IconUserGroupFilled />} size="md" css={{ color: 'icon.subtle' }} />}
      heading="No leads yet"
      headingLevel={4}
      align="left"
      css={{ height: '100%' }}
      body={showScreeningCriteriaCTA ? screeningCriteriaBody : undefined}
      secondaryAction={
        showScreeningCriteriaCTA ? { label: screeningCriteriaLabel, href: screeningCriteriaPath } : undefined
      }
    />
  );
};

export default NoInterestedRenters;
